import TextInput from '../../TextInput';
import React from 'react';
import OptionToggle from '../../OptionToggle.jsx';
import ShowPackageBalanceSettings from '~/components/forms/edit/components/ShowPackageBalanceSettings.jsx';
import { FEATURE_MARKETING, useFeatures } from '~/lib/Features.js';

const EditContactInfoForm = ({ settings, setSettings }) => {
    const {isEnabled} = useFeatures();
    const isMarketingEnabled = isEnabled(FEATURE_MARKETING);

    return (
        <div>
            <TextInput
                label="Label Prefix"
                placeholder=""
                className="my-4"
                inputClassName="w-full"
                value={settings?.labelPrefix || ''}
                onChange={value =>
                    setSettings({ ...settings, labelPrefix: value })
                }
            />

            <div className="panel-label mt-4">Options</div>
            <div className="panel p-4 mb-4">
                <OptionToggle
                    value={!settings?.disableGuestEntry}
                    onChange={() =>
                        setSettings({
                            ...settings,
                            disableGuestEntry: !settings?.disableGuestEntry,
                        })
                    }
                    title="Guest Info"
                    description="Ask for information about each guest if multiple spots are booked"
                />
                <ShowPackageBalanceSettings
                    settings={settings}
                    setSettings={setSettings}
                    className="mt-4"
                />
            </div>

            {isMarketingEnabled && (
                <>
                    <div className="panel-label mt-4">Marketing Opt In</div>
                    <div className="panel p-4 mb-4 text-gray-500 text-sm">
                        The marketing opt-in shows because Marketing Automations are enabled. Turn them off under Features & Integrations → Breely Features.
                    </div>
                </>
            )}
        </div>
    );
};

export default EditContactInfoForm;
